/*
Adjustable Shelf Standards

  --length <float> | inches
  --durability <boolean::switch> | ['Standard', 'Heavy Duty']
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Standards'
const id = 'y06fuu845lw3A50K0pco'

export default {
  name,
  id,
  filters,
  headers,
  form
}
